export default {
    "apiUrl": 'https://football-api.cactusminds.com/admin/',
}
